import React from 'react';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { Currency } from '../../../../../ui-toolkit';
import { ICheckDepositData } from '../../../../../types/order/escrow/ICheckDeposit';
import { getMismatchMessage } from '../../shared/getMismatchMessage';
import { convertColumnsToWrapBoldText } from '../../../../../utilities/escrowPortal/convertColumnsToWrapText';
import { nbsp } from '../../../../../utilities/administration/magicStrings';
import { prettyPayerType } from '../../../../../types/order/escrow/ePayerType';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

interface IColumnArgs {
  order: IOrderDetailsData;
}
export const generateCheckDepositTableColumns = ({
  order,
}: IColumnArgs): IBootstrapTableColumnProps<ICheckDepositData>[] =>
  convertColumnsToWrapBoldText<ICheckDepositData>([
    {
      text: 'Expected Amount',
      dataField: 'amountCents',
      sort: true,
      formatter: (cell: any, row?: ICheckDepositData) => {
        return row && <Currency value={cell} valueIsCents emptyContent={''} />;
      },
    },
    {
      text: 'Actual Amount',
      dataField: 'actualIncomingCheck',
      formatter: (cell: any, row?: ICheckDepositData) => {
        return (
          row &&
          row.actualIncomingCheck &&
          row.actualIncomingCheck.amountCents && (
            <Currency value={row.actualIncomingCheck.amountCents} valueIsCents emptyContent={''} />
          )
        );
      },
    },
    {
      text: 'Payer Type',
      dataField: 'payerType',
      sort: true,
      formatter: (cell: any) => prettyPayerType[cell],
    },
    {
      text: 'Identifier',
      dataField: 'checkIdentifier',
      sort: true,
    },
    {
      text: 'Check Detail',
      dataField: 'actualIncomingCheck',
      formatter: (cell: any, row?: ICheckDepositData) => {
        if (!row?.actualIncomingCheck?.checkDetail) {
          return null;
        }
        return JSON.stringify(row.actualIncomingCheck.checkDetail);
      },
    },
    {
      text: 'Bank Reference',
      dataField: 'actualIncomingCheck',
      formatter: (cell: any, row?: ICheckDepositData) => {
        return row?.actualIncomingCheck?.bankRef;
      },
    },
    {
      text: `Completed${nbsp}At`,
      dataField: 'actualIncomingCheck',
      formatter: (cell: any, row?: ICheckDepositData) =>
        getDateString(DateFormat.hugeDate, row?.actualIncomingCheck?.completedAtDate),
      sort: true,
    },
    {
      text: 'Mismatched',
      dataField: 'matched',
      formatter: (cell: any, row?: ICheckDepositData) => {
        return row && getMismatchMessage(order.orderInformation.created, row.matched);
      },
      sort: true,
    },
  ]);
